// Icon Constants - Store original icons for easy switching
import { BellOutlined, BugOutlined } from '@ant-design/icons';

// Original icons (saved for future use)
export const ORIGINAL_BELL_ICON = BellOutlined;
export const ORIGINAL_BUG_ICON = BugOutlined;

// Seasonal icons configuration
export const USE_SEASONAL_ICONS = true;

// Seasonal icon paths
export const SEASONAL_BELL_ICON_PATH = '/seasonal-bell-icon.png'; // Hot chocolate mug
export const SEASONAL_BUG_ICON_PATH = '/seasonal-bug-icon.png'; // Person rolling snowball

